"use client";

import { Trans, useLingui } from "@lingui/react/macro";
import { Button } from "@offstreetparking/design-system/forms";
import { DeleteIcon } from "@offstreetparking/design-system/icons/DeleteIcon";
import { VehicleIcon } from "@offstreetparking/design-system/icons/VehicleIcon";
import { Text } from "@offstreetparking/design-system/typography";
import { FlowModal as Modal } from "../overlays/FlowModal/FlowModal";
import { FlowModalTitle as ModalTitle } from "../overlays/FlowModal/FlowModalTitle";
type DeleteVehicleConfirmationModalProps = {
	isOpen: boolean;
	isLoading: boolean;
	plate: string;
	onClose: () => void;
	onConfirm: () => void;
};
export const DeleteVehicleConfirmationModal = ({
	isOpen,
	isLoading,
	plate,
	onClose,
	onConfirm,
}: DeleteVehicleConfirmationModalProps) => {
	const { t } = useLingui();
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			variant="fullScreen"
			i18n={{
				closeButton: t`Close`,
				cancelButton: t`Cancel`,
			}}
			actions={
				<>
					<Button
						intent="primary"
						isDestructive
						type="button"
						leftIcon={DeleteIcon}
						onClick={onConfirm}
						isLoading={isLoading}
					>
						{t`Remove vehicle`}
					</Button>
					<Button intent="secondary" type="button" onClick={onClose} isDisabled={isLoading}>
						{t`Cancel`}
					</Button>
				</>
			}
		>
			<ModalTitle
				variant="fullScreen"
				icon={<VehicleIcon className="h-5 w-5" />}
				onClose={onClose}
				i18n={{
					closeButton: t`Close`,
				}}
			>
				{t`Remove Vehicle`}
			</ModalTitle>
			<Text>
				<Trans>
					Removing vehicle <b>{plate}</b> won't remove it from existing permits. Update permits separately if
					needed.
				</Trans>
			</Text>
		</Modal>
	);
};
